'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dPush$002dNotification from "./app.api.-General-Practice-App-Update$-Push-Notification.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$82() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$82 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$82 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$82;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$82() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$82 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$82 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.apply__Lapp_api_GeneralPracticeAppUpdate__Z = (function(a) {
  return ((a instanceof $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dPush$002dNotification.$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification) && (a !== null));
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_api_GeneralPracticeAppUpdate__Z(v1);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$82.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_api_GeneralPracticeAppUpdate__Z(v1);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$82 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$82, "app.api.GeneralPracticeAppUpdate$$anon$82", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$82: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$82 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$82 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$82.js.map
